import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { ReponseData2 } from '../../../types'
import { VacationScheduleType } from '../../../types/vacationSchedule'
import { axiosBaseQuery } from '../../baseQuery'

export const vacationScheduleApi = createApi({
  reducerPath: 'vacationScheduleApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['VacationSchedule'],
  endpoints: (builder) => ({
    getListVacationSchedule: builder.query({
      query: (params) => ({
        url: NetWork.vacationSchedule,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: VacationScheduleType[] }>) =>
          result ? [{ type: 'VacationSchedule', id: 'LIST' }] : []
      })
    }),
    getVacationScheduleById: builder.query({
      query: (params: { vacationScheduleId: number }) => ({
        url: NetWork.vacationScheduleId(params.vacationScheduleId),
        method: GET
      })
    }),
    addVacationSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.vacationSchedule,
        method: POST,
        data: data
      })
    }),
    updateVacationSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.vacationScheduleId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteVacationSchedule: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.vacationSchedule,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'VacationSchedule', id: 'LIST' }] // Vô hiệu hóa tag 'VacationSchedule' với id 'LIST' để gọi lại getListVacationSchedule
      })
    }),
    changeStatusVacationSchedule: builder.mutation({
      query: (data: { vacationScheduleId: number; params: { isActive: boolean } }) => ({
        url: NetWork.vacationScheduleId(data.vacationScheduleId),
        method: PATCH,
        params: data.params
      })
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListVacationScheduleQuery,
  useDeleteVacationScheduleMutation,
  useAddVacationScheduleMutation,
  useGetVacationScheduleByIdQuery,
  useUpdateVacationScheduleMutation,
  useChangeStatusVacationScheduleMutation
} = vacationScheduleApi
